import { lowerCase } from 'lodash';

const isTextColumn = keyName =>
  lowerCase(keyName) === 'month' ||
  keyName === 'tenant' ||
  keyName === 'client_name' ||
  keyName === 'root_domain_auth' ||
  keyName === 'environment' ||
  keyName === 'connection_name' ||
  lowerCase(keyName) === 'day';

export default isTextColumn;
